import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/no-record.png'


const _withScopeId = n => (_pushScopeId("data-v-0e86f308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "active-box" }
const _hoisted_2 = {
  key: 0,
  class: "active-list"
}
const _hoisted_3 = { class: "top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "txt-box" }
const _hoisted_6 = { class: "bottom-box" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  disabled: ""
}
const _hoisted_9 = {
  key: 1,
  class: "no-record"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂时没有直播哦", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { MessageFetch, UserService } from '../api/request';
import { onMounted, ref } from 'vue';
import { ISjqnwArticleProps } from '@/api/type';
import config from '@/_config';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const list = ref<ISjqnwArticleProps[]>([]);

const activeName = ref('first');
const onLoad = async(type: string) => {
  const res = await MessageFetch.getUsLivesScheduleInfos({
    tab: type
  });
  if (res.code === '00') {
    const body = res.body;
    list.value = body;
  }
};
const toLive = (item) => {
  if (window.localStorage.getItem('authToken')) {
    const mobile = window.localStorage.getItem('mobile');
    UserService.getMoveToken({ mobile: mobile }).then((res) => {
      if (res.body) {
        window.location.href = `${item.shareUrl}&sjqnToken=${res.body}`;
      } else {
        window.location.href = `${item.shareUrl}&mobile=${mobile}`;
      }
    });
  } else {
    window.location.href = item.shareUrl;
  }
};

const handleClick = ({ title }) => {
  onLoad(title == '直播计划' ? '1' : '2');
};
onMounted(() => {
  onLoad('1');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (list.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-content",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _unref(config).articleUrl + item.backGroupUrl,
                  alt: ""
                }, null, 8, _hoisted_4),
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h4", null, _toDisplayString(item.summary), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", null, "开始时间：" + _toDisplayString(item.startTime.slice(5)), 1),
                  (item.status == '1')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (toLive(item))
                      }, " 去观看 ", 8, _hoisted_7))
                    : (_openBlock(), _createElementBlock("button", _hoisted_8, "即将开始"))
                ])
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
  ]))
}
}

})